module.exports = __webpack_public_path__ + "static/media/people.9da423d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/people.png
// module id = 2987
// module chunks = 0